import { dew as _toHexDew } from "../../utils/encoding/toHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setMinGasPrice = void 0;
  const toHex_js_1 = _toHexDew();
  async function setMinGasPrice(client, {
    gasPrice
  }) {
    await client.request({
      method: `${client.mode}_setMinGasPrice`,
      params: [(0, toHex_js_1.numberToHex)(gasPrice)]
    });
  }
  exports.setMinGasPrice = setMinGasPrice;
  //# sourceMappingURL=setMinGasPrice.js.map
  return exports;
}